import { Link } from "wouter";

export default function Footer() {
  const basePath = import.meta.env.BASE_URL.replace(/\/$/, "");

  return (
    <footer className="border-t bg-muted/40 text-muted-foreground">
      <div className="container px-4 py-12 md:px-8 flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="flex items-center gap-4">
          <img
            src={`${basePath}/logo.jpeg`}
            alt="Greater Hope Service Dogs"
            className="h-12 w-12 rounded-full grayscale opacity-70"
          />
          <div>
            <p className="font-semibold text-foreground">
              Greater Hope Service Dogs
            </p>
            <p className="text-sm">Changing lives, one dog at a time.</p>
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm">
          <Link href="/" className="hover:text-foreground transition-colors">
            Home
          </Link>
          <Link
            href="/about"
            className="hover:text-foreground transition-colors"
          >
            About
          </Link>
          <Link
            href="/ways-to-give"
            className="hover:text-foreground transition-colors"
          >
            Ways to Give
          </Link>
          <Link
            href="/contact"
            className="hover:text-foreground transition-colors"
          >
            Contact
          </Link>
          <Link
            href="/sign-in"
            className="hover:text-foreground transition-colors"
          >
            Raiser Login
          </Link>
        </div>
      </div>
    </footer>
  );
}
